import dynamic from "next/dynamic"
import * as editorConfigs from "constants-lib/aemComponentEditorConfigs"
import { CustomResponsiveGrid } from "./ResponsiveGrid/ResponsiveGridContainer"

const MAPPED_COMPONENTS = {
  [editorConfigs.MobileCallToOrderMappedPath]: dynamic(() =>
    import("component-lib/AEM/MobileCallToOrder/MobileCallToOrderContainer"),
  ),
  [editorConfigs.ADSRegistrationConfirmationMappedPath]: dynamic(() =>
    import(
      "component-lib/AEM/ADSRegistrationConfirmation/ADSRegistrationConfirmationContainer"
    ),
  ),
  [editorConfigs.TwoColumnTextMappedPath]: dynamic(() =>
    import("component-lib/AEM/TwoColumnText/TwoColumnTextContainer"),
  ),
  [editorConfigs.BreadcrumbBannerMappedPath]: dynamic(() =>
    import("component-lib/AEM/BreadcrumbBanner/BreadcrumbBannerContainer").then(
      (module) => module.WrappedComponentWithCmsContent,
    ),
  ),
  [editorConfigs.HighlightedStatsMappedPath]: dynamic(() =>
    import("component-lib/AEM/HighlightedStats/HighlightedStatsContainer"),
  ),
  [editorConfigs.ContactBackMappedPath]: dynamic(() =>
    import("component-lib/AEM/ContactBack/ContactBackContainer"),
  ),
  [editorConfigs.UnsubscribeFeedbackMappedPath]: dynamic(() =>
    import(
      "component-lib/AEM/UnsubscribeFeedback/UnsubscribeFeedbackContainer"
    ).then((module) => module.WrappedComponentWithCmsContent),
  ),
  [editorConfigs.ReviewCarouselMappedPath]: dynamic(() =>
    import("component-lib/AEM/ReviewCarousel/ReviewCarouselContainer"),
  ),
  [editorConfigs.HelpMeChooseMappedPath]: dynamic(() =>
    import("component-lib/AEM/HelpMeChoose/HelpMeChooseContainer"),
  ),
  [editorConfigs.CheckAvailabilityModalMappedPath]: dynamic(() =>
    import(
      "component-lib/AEM/CheckAvailabilityModal/CheckAvailabilityModalContainer"
    ),
  ),
  [editorConfigs.TonnageOverageMappedPath]: dynamic(() =>
    import("component-lib/AEM/TonnageOverage/TonnageOverageContainer"),
  ),
  [editorConfigs.ImageMosaicMappedPath]: dynamic(() =>
    import("component-lib/AEM/ImageMosaic/ImageMosaicContainer"),
  ),
  [editorConfigs.ComparisonTableMappedPath]: dynamic(
    () => import("component-lib/AEM/ComparisonTable/ComparisonTableContainer"),
    { ssr: false },
  ),
  [editorConfigs.CustomerSupportMappedPath]: dynamic(() =>
    import("component-lib/AEM/CustomerSupport/CustomerSupportContainer"),
  ),
  [editorConfigs.VideoMappedPath]: dynamic(() =>
    import("component-lib/AEM/Video/VideoContainer"),
  ),
  [editorConfigs.SideNavMappedPath]: dynamic(() =>
    import("component-lib/AEM/SideNav/SideNavContainer"),
  ),
  [editorConfigs.BreadcrumbHeaderMappedPath]: dynamic(() =>
    import("component-lib/AEM/BreadcrumbHeader/BreadcrumbHeaderContainer"),
  ),
  [editorConfigs.TopicsPageMappedPath]: dynamic(
    () => import("component-lib/AEM/TopicsPage/TopicsPageContainer"),
    { ssr: false },
  ),
  [editorConfigs.RequestContainerRepairMappedPath]: dynamic(() =>
    import(
      "component-lib/AEM/RequestContainerRepair/RequestContainerRepairContainer"
    ),
  ),
  [editorConfigs.ProductCarouselMappedPath]: dynamic(() =>
    import("component-lib/AEM/ProductCarousel/ProductCarouselContainer"),
  ),
  [editorConfigs.EnergySurchargeCalculatorMappedPath]: dynamic(() =>
    import(
      "component-lib/AEM/EnergySurchargeCalculator/EnergySurchargeCalculatorContainer"
    ),
  ),
  [editorConfigs.CommunicationPreferencesMappedPath]: dynamic(
    () =>
      import(
        "component-lib/AEM/CommunicationPreferences/CommunicationPreferencesContainer"
      ).then((module) => module.WrappedComponentWithCmsContent),
    { ssr: false },
  ),
  [editorConfigs.WidgetModalMappedPath]: dynamic(() =>
    import("component-lib/AEM/WidgetModal/WidgetModalContainer"),
  ),
  [editorConfigs.LicensingAgreementModalMappedPath]: dynamic(() =>
    import(
      "component-lib/AEM/LicensingAgreementModal/LicensingAgreementModalContainer"
    ),
  ),
  [editorConfigs.ContentAccordionMappedPath]: dynamic(
    () =>
      import("component-lib/AEM/ContentAccordion/ContentAccordionContainer"),
    { ssr: false },
  ),
  [editorConfigs.TabbedContentMappedPath]: dynamic(() =>
    import("component-lib/AEM/TabbedContent/TabbedContentContainer"),
  ),
  [editorConfigs.CTABreakerMappedPath]: dynamic(() =>
    import("component-lib/AEM/CTABreaker/CTABreakerContainer"),
  ),
  [editorConfigs.SimplifiedFooterMappedPath]: dynamic(() =>
    import("component-lib/AEM/SimplifiedFooter/SimplifiedFooterContainer"),
  ),
  [editorConfigs.HolidayScheduleMappedPath]: dynamic(() =>
    import("component-lib/AEM/HolidaySchedule/HolidayScheduleContainer"),
  ),
  [editorConfigs.AddressSelectorDropdownMappedPath]: dynamic(
    import(
      "component-lib/AEM/AddressSelectorDropdown/containers/AddressSelectorDropdownContainer"
    ).then((module) => module.WrappedComponentWithCmsContent),
  ),
  [editorConfigs.ProductAvailabilityMappedPath]: dynamic(() =>
    import(
      "component-lib/AEM/ProductAvailability/ProductAvailabilityContainer"
    ),
  ),
  [editorConfigs.AddressSearchBarMappedPath]: dynamic(() =>
    import("component-lib/AEM/ResiBulkAddressBar/AddressSearchBarContainer"),
  ),
  [editorConfigs.EntryAndContactMappedPath]: dynamic(() =>
    import("component-lib/AEM/EntryAndContact/EntryAndContactContainer"),
  ),
  [editorConfigs.ProductDescriptionMappedPath]: dynamic(() =>
    import("component-lib/AEM/ProductDescription/ProductDescriptionContainer"),
  ),
  [editorConfigs.SupportSearchMappedPath]: dynamic(() =>
    import("component-lib/AEM/SupportSearch/SupportSearchContainer"),
  ),
  [editorConfigs.InteractiveMapMappedPath]: dynamic(() =>
    import("component-lib/AEM/InteractiveMap/InteractiveMapContainer"),
  ),
  [editorConfigs.FeaturedContentCardsMappedPath]: dynamic(() =>
    import(
      "component-lib/AEM/FeaturedContentCards/FeaturedContentCardsContainer"
    ),
  ),
  [editorConfigs.SiteSearchMappedPath]: dynamic(() =>
    import("component-lib/SiteSearch/SiteSearchContainer"),
  ),
  [editorConfigs.LoginFormMappedPath]: dynamic(() =>
    import("component-lib/AEM/LoginForm/LoginFormContainer").then(
      (module) => module.WrappedComponentWithCmsContent,
    ),
  ),
  [editorConfigs.StickyCardsScrollableTextMappedPath]: dynamic(() =>
    import(
      "component-lib/AEM/StickyCardsScrollableText/StickyCardsScrollableTextContainer"
    ),
  ),
  [editorConfigs.BasicHeroMappedPath]: dynamic(() =>
    import("component-lib/AEM/BasicHero/BasicHeroContainer"),
  ),
  [editorConfigs.SupportFormsMappedPath]: dynamic(() =>
    import("component-lib/AEM/SupportForms/SupportFormsContainer"),
  ),
  [editorConfigs.CommercialServiceMappedPath]: dynamic(() =>
    import("component-lib/AEM/CommercialService/CommercialServiceContainer"),
  ),
  [editorConfigs.ProductDisclaimerMappedPath]: dynamic(() =>
    import("component-lib/AEM/ProductDisclaimer/ProductDisclaimerContainer"),
  ),
  [editorConfigs.GuidedFlowMappedPath]: dynamic(() =>
    import("component-lib/AEM/GuidedFlow/GuidedFlowContainer"),
  ),
  [editorConfigs.VirtualTourMappedPath]: dynamic(() =>
    import("component-lib/AEM/VirtualTour/VirtualTourContainer"),
  ),
  [editorConfigs.ConfirmationMappedPath]: dynamic(() =>
    import("component-lib/AEM/Confirmation/ConfirmationContainer"),
  ),
  [editorConfigs.HeroImageMappedPath]: dynamic(() =>
    import("component-lib/AEM/HeroImage/HeroImageContainer"),
  ),
  [editorConfigs.SingleColumnTextMappedPath]: dynamic(() =>
    import("component-lib/AEM/SingleColumnText/SingleColumnTextContainer"),
  ),
  [editorConfigs.FullWidthImageVideoMappedPath]: dynamic(() =>
    import(
      "component-lib/AEM/FullWidthImageVideo/FullWidthImageVideoContainer"
    ),
  ),
  [editorConfigs.ProductSelectionMappedPath]: dynamic(() =>
    import("component-lib/AEM/ProductSelection/ProductSelectionContainer"),
  ),
  [editorConfigs.ImageMappedPath]: dynamic(() =>
    import("component-lib/AEM/Image/ImageContainer"),
  ),
  [editorConfigs.TopTopicsMappedPath]: dynamic(() =>
    import("component-lib/AEM/TopTopics/TopTopicsContainer"),
  ),
  [editorConfigs.ProductComparisonTableMappedPath]: dynamic(() =>
    import(
      "component-lib/AEM/ProductComparisonTable/ProductComparisonTableContainer"
    ),
  ),
  [editorConfigs.ServiceComparisonMappedPath]: dynamic(() =>
    import("component-lib/AEM/ServiceComparison/ServiceComparisonContainer"),
  ),
  [editorConfigs.SimplifiedNavigationMappedPath]: dynamic(() =>
    import(
      "component-lib/AEM/SimplifiedNavigation/SimplifiedNavigationContainer"
    ),
  ),
  [editorConfigs.LeadCaptureFormMappedPath]: dynamic(() =>
    import("component-lib/AEM/LeadCaptureForm/LeadCaptureFormContainer"),
  ),
  [editorConfigs.HorizontalListMappedPath]: dynamic(() =>
    import("component-lib/AEM/HorizontalList/HorizontalListContainer"),
  ),
  [editorConfigs.ThreeColumnContentBlocksMappedPath]: dynamic(() =>
    import(
      "component-lib/AEM/ThreeColumnContentBlocks/ThreeColumnContentBlocksContainer"
    ),
  ),
  [editorConfigs.ProductComparisonTableWithoutPriceMappedPath]: dynamic(() =>
    import(
      "component-lib/AEM/ProductComparisonTableWithoutPrice/ProductComparisonTableWithoutPriceContainer"
    ),
  ),
  [editorConfigs.HeaderBasicMappedPath]: dynamic(() =>
    import("component-lib/AEM/HeaderBasic/HeaderBasicContainer"),
  ),
  [editorConfigs.DisclaimerWithCTAMappedPath]: dynamic(() =>
    import("component-lib/AEM/DisclaimerWithCTA/DisclaimerWithCTAContainer"),
  ),
  [editorConfigs.CrossPollinationMappedPath]: dynamic(() =>
    import("component-lib/AEM/CrossPollination/CrossPollinationContainer"),
  ),
  [editorConfigs.MapMappedPath]: dynamic(() =>
    import("component-lib/AEM/Map/MapContainer"),
  ),
  [editorConfigs.DatePickupSelectorMappedPath]: dynamic(() =>
    import("component-lib/AEM/DatePickupSelector/DatePickupSelectorContainer"),
  ),
  [editorConfigs.FormOnPageMappedPath]: dynamic(() =>
    import("component-lib/AEM/FormOnPage/FormOnPageContainer"),
  ),
  [editorConfigs.VideoPlayListMappedPath]: dynamic(() =>
    import("component-lib/AEM/VideoPlayList/VideoPlayListContainer"),
  ),
  [editorConfigs.CardGridMappedPath]: dynamic(() =>
    import("component-lib/AEM/CardGrid/CardGridContainer"),
  ),
  [editorConfigs.BreadcrumbStandaloneMappedPath]: dynamic(() =>
    import(
      "component-lib/AEM/BreadcrumbStandalone/BreadcrumbStandaloneContainer"
    ),
  ),
  [editorConfigs.ContactUsMappedPath]: dynamic(() =>
    import("component-lib/AEM/ContactUs/ContactUsContainer"),
  ),
  [editorConfigs.FooterBasicMappedPath]: dynamic(() =>
    import("component-lib/AEM/FooterBasic/FooterBasicContainer"),
  ),
  [editorConfigs.MultimediaMappedPath]: dynamic(() =>
    import("component-lib/AEM/Multimedia/MultimediaContainer"),
  ),
  [editorConfigs.ManageContactsMappedPath]: dynamic(
    import("component-lib/AEM/ManageContacts/ManageContactsContainer").then(
      (module) => module.WrappedComponentWithCmsContent,
    ),
    { ssr: false },
  ),
  [editorConfigs.CallBackFormMappedPath]: dynamic(() =>
    import("component-lib/AEM/CallBackForm/CallBackFormContainer"),
  ),
  [editorConfigs.StoryMosaicMappedPath]: dynamic(() =>
    import("component-lib/AEM/StoryMosaic/StoryMosaicContainer"),
  ),
  [editorConfigs.AccordionListMappedPath]: dynamic(() =>
    import("component-lib/AEM/AccordionList/AccordionListContainer"),
  ),
  [editorConfigs.LiveChatROMappedPath]: dynamic(() =>
    import("component-lib/AEM/LiveChatRO/LiveChatROContainer"),
  ),
  [editorConfigs.RequestSupportMappedPath]: dynamic(() =>
    import("component-lib/AEM/RequestSupport/RequestSupportContainer"),
  ),
  [editorConfigs.ImageVideoHeroMappedPath]: dynamic(() =>
    import("component-lib/AEM/ImageVideoHero/ImageVideoHeroContainer"),
  ),
  [editorConfigs.RelatedArticlesMappedPath]: dynamic(() =>
    import("component-lib/AEM/RelatedArticles/RelatedArticlesContainer"),
  ),
  [editorConfigs.LinkGridTileMappedPath]: dynamic(() =>
    import("component-lib/AEM/LinkGridTile/LinkGridTileContainer"),
  ),
  [editorConfigs.FormModalMappedPath]: dynamic(() =>
    import("component-lib/AEM/FormModal/FormModalContainer"),
  ),
  [editorConfigs.ThreeColumnReportMetricsMappedPath]: dynamic(() =>
    import(
      "component-lib/AEM/ThreeColumnReportMetrics/ThreeColumnReportMetricsContainer"
    ),
  ),
  [editorConfigs.ErrorPageMappedPath]: dynamic(() =>
    import("component-lib/AEM/ErrorPage/ErrorPageContainer"),
  ),
  [editorConfigs.MadlibMappedPath]: dynamic(() =>
    import("component-lib/AEM/Madlib/MadlibContainer"),
  ),
  [editorConfigs.HeroImageVideoMappedPath]: dynamic(() =>
    import("component-lib/AEM/HeroImageVideo/HeroImageVideoContainer"),
  ),
  [editorConfigs.TopSupportTopicsMappedPath]: dynamic(() =>
    import("component-lib/AEM/TopSupportTopics/TopSupportTopicsContainer"),
  ),
  [editorConfigs.QuizGameMappedPath]: dynamic(() =>
    import("component-lib/AEM/QuizGame/QuizGameContainer"),
  ),
  [editorConfigs.FullWidthAutoPlayVideoMappedPath]: dynamic(() =>
    import(
      "component-lib/AEM/FullWidthAutoPlayVideo/FullWidthAutoPlayVideoContainer"
    ),
  ),
  [editorConfigs.FloatingADSRegistrationCardMappedPath]: dynamic(() =>
    import(
      "component-lib/AEM/FloatingADSRegistrationCard/FloatingADSRegistrationCardContainer"
    ),
  ),
  [editorConfigs.StoryCarouselMappedPath]: dynamic(() =>
    import("component-lib/AEM/StoryCarousel/StoryCarouselContainer"),
  ),
  [editorConfigs.TabbedAddressSearchMappedPath]: dynamic(() =>
    import(
      "component-lib/AEM/TabbedAddressSearch/TabbedAddressSearchContainer"
    ),
  ),
  [editorConfigs.StickySubNavMappedPath]: dynamic(() =>
    import("component-lib/AEM/StickySubNav/StickySubNavContainer"),
  ),
  [editorConfigs.ValuePropositionMappedPath]: dynamic(() =>
    import("component-lib/AEM/ValueProposition/ValuePropositionContainer"),
  ),
  [editorConfigs.DiagramAnnotationMappedPath]: dynamic(() =>
    import("component-lib/AEM/DiagramAnnotation/DiagramAnnotationContainer"),
  ),
  [editorConfigs.RadioListMappedPath]: dynamic(() =>
    import("component-lib/AEM/RadioList/RadioListContainer"),
  ),
  [editorConfigs.HomepageAddressInputMappedPath]: dynamic(() =>
    import(
      "component-lib/AEM/HomepageAddressInput/HomepageAddressInputContainer"
    ),
  ),
  [editorConfigs.MDSGraphicMappedPath]: dynamic(() =>
    import("component-lib/AEM/MDSGraphic/MDSGraphicContainer"),
  ),
  [editorConfigs.CheckListMappedPath]: dynamic(() =>
    import("component-lib/AEM/CheckList/CheckListContainer"),
  ),
  [editorConfigs.BulkFormMappedPath]: dynamic(() =>
    import("component-lib/AEM/BulkForm/BulkFormContainer"),
  ),
  [editorConfigs.ResidentialServiceMappedPath]: dynamic(() =>
    import("component-lib/AEM/ResidentialService/ResidentialServiceContainer"),
  ),
  [editorConfigs.FeaturedImageWithMetricsMappedPath]: dynamic(() =>
    import(
      "component-lib/AEM/FeaturedImageWithMetrics/FeaturedImageWithMetricsContainer"
    ),
  ),
  [editorConfigs.RatingsReviewsMappedPath]: dynamic(() =>
    import("component-lib/AEM/RatingsReviews/RatingsReviewsContainer"),
  ),
  [editorConfigs.FeedbackSurveyMappedPath]: dynamic(() =>
    import("component-lib/AEM/FeedbackSurvey/FeedbackSurveyContainer"),
  ),
  // custom core components implementations
  [editorConfigs.CustomCoreAccordionMappedPath]: dynamic(() =>
    import("component-lib/AEM/containers/Accordion/AccordionContainer"),
  ),
  [editorConfigs.CustomResponsiveGridMappedPath]: CustomResponsiveGrid,
}

export default MAPPED_COMPONENTS
